import { motion } from 'framer-motion';
import { ShieldCheck, Smartphone } from 'lucide-react';
import { useState, useEffect } from 'react';

export default function OTPScene({ onNext }) {
  const [otpDigits, setOtpDigits] = useState(['', '', '', '', '', '']);
  useEffect(() => {
    const targetOtp = ['4', '8', '2', '7', '1', '5'];
    const timers = targetOtp.map((digit, i) =>
      setTimeout(() => {
        setOtpDigits(prev => {
          const next = [...prev];
          next[i] = digit;
          return next;
        });
      }, 1500 + i * 300)
    );
    return () => timers.forEach(clearTimeout);
  }, []);

  return (
    <div data-testid="scene-otp" className="flex flex-col items-center justify-center h-full px-8">
      <motion.div
        initial={{ opacity: 0 }}
        animate={{ opacity: 1 }}
        className="w-full max-w-lg"
      >
        <motion.div
          initial={{ opacity: 0, y: -10 }}
          animate={{ opacity: 1, y: 0 }}
          className="text-center mb-10"
        >
          <span className="inline-flex items-center gap-2 px-3 py-1.5 rounded-full text-xs font-body font-medium bg-teal-600/10 text-teal-700 mb-4">
            <ShieldCheck size={14} /> Step 5
          </span>
          <h2 className="font-heading font-bold text-4xl md:text-5xl tracking-tight text-[#0A0A0A]">
            OTP Verification
          </h2>
          <p className="mt-3 font-body text-lg text-[#737373]">
            User verifies identity with a one-time password
          </p>
        </motion.div>

        <motion.div
          initial={{ opacity: 0, y: 20, scale: 0.98 }}
          animate={{ opacity: 1, y: 0, scale: 1 }}
          transition={{ delay: 0.3, duration: 0.6 }}
          className="bg-white rounded-2xl border border-black/5 shadow-2xl p-10 text-center"
        >
          <motion.div
            initial={{ scale: 0 }}
            animate={{ scale: 1 }}
            transition={{ delay: 0.5, type: 'spring', stiffness: 200 }}
            className="w-16 h-16 rounded-2xl bg-teal-600/10 flex items-center justify-center mx-auto mb-6"
          >
            <Smartphone size={28} className="text-teal-600" />
          </motion.div>

          <h3 className="font-heading font-bold text-xl text-[#0A0A0A] mb-2">Enter Verification Code</h3>
          <p className="font-body text-sm text-[#737373] mb-8">
            We sent a 6-digit code to ahmed.rashid@alnoor.ae
          </p>

          {/* OTP Input */}
          <div data-testid="otp-input-group" className="flex items-center justify-center gap-3 mb-8">
            {otpDigits.map((digit, i) => (
              <motion.div
                key={i}
                initial={{ scale: 0.8, opacity: 0.3 }}
                animate={{
                  scale: digit ? 1 : 0.95,
                  opacity: digit ? 1 : 0.4,
                  borderColor: digit ? '#0D9488' : '#E5E7EB',
                }}
                transition={{ duration: 0.2 }}
                className="w-14 h-16 rounded-xl border-2 flex items-center justify-center bg-[#FAFAFA]"
              >
                <motion.span
                  initial={{ opacity: 0, scale: 0.5 }}
                  animate={{ opacity: digit ? 1 : 0, scale: digit ? 1 : 0.5 }}
                  className="font-heading font-bold text-2xl text-[#0A0A0A]"
                >
                  {digit}
                </motion.span>
              </motion.div>
            ))}
          </div>

          <motion.button
            data-testid="verify-otp-button"
            initial={{ opacity: 0.5 }}
            animate={{ opacity: otpDigits.every(d => d) ? 1 : 0.5 }}
            onClick={onNext}
            className="w-full py-3.5 rounded-xl bg-teal-600 text-white font-body font-bold text-sm tracking-wide hover:-translate-y-0.5 transition-transform cursor-pointer"
          >
            Verify Code
          </motion.button>

          <motion.p
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            transition={{ delay: 1 }}
            className="mt-4 font-body text-xs text-[#737373]"
          >
            Didn't receive the code? <span className="text-teal-700 font-medium cursor-pointer">Resend</span>
          </motion.p>
        </motion.div>
      </motion.div>
    </div>
  );
}
